export function getDateRangeFilter(dateStr:string, fieldName = "dateCreated") {
    // Split DD/MM/YYYY
    const [day, month, year] = dateStr.split("/").map(Number);
  
    // Start of the day (UTC)
    const start = new Date(Date.UTC(year, month - 1, day));
  
    // Next day for the "lt" range
    const end = new Date(start);
    end.setUTCDate(start.getUTCDate() + 1);
  
    // ISO format without milliseconds
    const startISO = start.toISOString().replace(".000", "");
    const endISO = end.toISOString().replace(".000", "");
  
    return `${fieldName} ge ${startISO} and ${fieldName} lt ${endISO}`;
  }
  export function addDaysToDate(baseDate: string, daysToAdd: number): string {
    const date = new Date(baseDate);
    date.setDate(date.getDate() + daysToAdd - 1);

    // Keep format "YYYY-MM-DDTHH:mm:ssZ"
    return date.toISOString().split('.')[0] + "Z";
}

export function convertFromISO(isoString: string) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
}
